import axios from 'axios';
import qs from 'query-string';
import { get, keys, forEach } from 'lodash';

import * as Constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { AXIOS_DEFAULT_OPTIONS } from '../';

const fetchQueryString = (params) => {
  let queryString = qs.stringify(params, true);
  queryString = queryString ? `?${queryString}` : '';
  return queryString;
};

export const fetchAPIKeySettings = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/application-settings`;

    dispatch({
      type: Constants.KEY_SETTINGS_GET_REQUEST,
    });

    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: Constants.KEY_SETTINGS_GET_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.KEY_SETTINGS_GET_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateAPIKeySettings = (
    data,
    updateKeysWithNoExpiryDays,
    updateKeysWithExcessExpiryDays,
  ) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const queryString = fetchQueryString({
      updateKeysWithNoExpiryDays,
      updateKeysWithExcessExpiryDays,
    });
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/application-settings${queryString}`;

    dispatch({
      type: Constants.KEY_SETTINGS_UPDATE_REQUEST,
    });

    await axios.put(url, data, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.KEY_SETTINGS_UPDATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        const validationErrors = get(error, 'response.data.validationErrors');
        const errorFields = keys(validationErrors);
        let errorMessage = '';
        forEach(errorFields, field => {
          errorMessage += get(validationErrors, `${field}.devMessage`);
        });
        dispatch({
          type: Constants.KEY_SETTINGS_UPDATE_ERROR,
          payload: {
            errorFields,
            message: errorMessage,
          },
        });
      });
  };

export const executeExpiryJob = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/api-keys/key-expiry-task`;

    dispatch({
      type: Constants.EXECUTE_EXPIRY_JOB_REQUEST,
    });

    await axios.post(url, {}, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.EXECUTE_EXPIRY_JOB_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        const validationErrors = get(error, 'response.data.validationErrors');
        dispatch({
          type: Constants.EXECUTE_EXPIRY_JOB_ERROR,
          payload: {
            errors: validationErrors,
          },
        });
      });
  };

export const executeExpiryReportingJob = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/api-keys/expiry-reports`;

    dispatch({
      type: Constants.EXECUTE_EXPIRY_REPORTING_JOB_REQUEST,
    });

    await axios.post(url, {}, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.EXECUTE_EXPIRY_REPORTING_JOB_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        const validationErrors = get(error, 'response.data.validationErrors');
        dispatch({
          type: Constants.EXECUTE_EXPIRY_REPORTING_JOB_ERROR,
          payload: {
            errors: validationErrors,
          },
        });
      });
  };
